<template>
  <div class="field">
    <div class="label-wrapper">
      <label
        v-if="label && label.length > 0"
        class="label"
        v-html="label"
      />
      <a
        v-if="isPasswordInput"
        href="#"
        class="input-action has-text-grey"
        @click.prevent="togglePwdVisibility"
      >
        <span v-if="!visiblePwd">
          <Eye />&nbsp;View
        </span>
        <span v-else>
          <EyeOff />&nbsp;Hide
        </span>

      </a>
    </div>
    <div class="control">
      <input
        v-model="value"
        v-bind="setInputAttrs"
        class="input"
        @blur="emitChange"
        @keyup="emitKeypress"
        @change="emitInstantChange"
      >
    </div>
    <p
      v-if="message"
      :class="message.class"
      class="help"
      v-text="message.value"
    />
  </div>
</template>

<script>
import Eye from 'vue-material-design-icons/Eye.vue'
import EyeOff from 'vue-material-design-icons/EyeOff.vue'

export default {
  name: 'TextField',
  components: {
    Eye,
    EyeOff
  },
  data () {
    return {
      value: '',
      localType: 'text',
      visiblePwd: false
    }
  },
  props: {
    initialValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    extraClass: {
      type: String,
      default: ''
    },
    label: {
      type: [Boolean, String],
      default: false
    },
    message: {
      type: [Boolean, Object],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    shouldAutocomplete: {
      type: String,
      default: 'on'
    }
  },
  mounted () {
    this.value = this.initialValue
    this.localType = this.type
  },
  watch: {
    initialValue () {
      this.value = this.initialValue
    }
  },
  computed: {
    isPasswordInput () {
      return this.type === 'password'
    },
    setInputAttrs () {
      return {
        type: this.localType,
        placeholder: this.placeholder,
        class: this.extraClass,
        name: this.name,
        disabled: this.disabled,
        autocomplete: this.shouldAutocomplete
      }
    }
  },
  methods: {
    emitChange () {
      this.$emit('changedValue', this.value)
    },
    emitInstantChange () {
      this.$emit('instantChangedValue', this.value)
    },
    emitKeypress () {
      this.$emit('keypress', this.value)
    },
    togglePwdVisibility () {
      this.visiblePwd = !this.visiblePwd
      if (this.localType === 'password') {
        this.localType = 'text'
      } else {
        this.localType = 'password'
      }
    }
  }
}
</script>

<style lang="scss">
  .label-wrapper{
    display: flex;
    justify-content: space-between;
  }
</style>
